import { render } from "./UserProfileRead.vue?vue&type=template&id=e93128fa&scoped=true"
import script from "./UserProfileRead.vue?vue&type=script&lang=js"
export * from "./UserProfileRead.vue?vue&type=script&lang=js"

import "./UserProfileRead.vue?vue&type=style&index=0&id=e93128fa&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e93128fa"]])

export default __exports__